import Axios from 'axios'

import { addressHasRequiredFields, mapStateToFullName } from '@/helpers'

import { PLACES_KEY } from '@/services/Configuration'

import { log, error } from '@/services/Log'

export const getAddressObjectFromPlacesAPI = ({ address_components }) => {
    // Parse Places API address components -- http://goo.gle/3l5i5Mr
    const getAddressComponent = (type, version = 'long_name') => address_components.find(({ types }) => types.includes(type))?.[version] || "";

    const streetNumber = getAddressComponent('street_number')
    const streetName = getAddressComponent('route')
    const street1 = `${streetNumber} ${streetName}`

    const street2 = getAddressComponent('subpremise')

    // postal_code_suffix has been deactivated by TAB-830
    const zipSuffix = '' // getAddressComponent('postal_code_suffix')
    const zipPrefix = getAddressComponent('postal_code')
    const zip = zipSuffix ? `${zipPrefix}-${zipSuffix}` : zipPrefix;

    const stateAcronym = getAddressComponent('administrative_area_level_1', 'short_name')

    const borough = getAddressComponent('sublocality_level_1')
    const city = getAddressComponent('locality') || borough

    const hasAllRequiredFields = (
        !!streetName &&
        !!streetNumber &&
        !!city &&
        !!stateAcronym &&
        !!zipPrefix
    )

    if(!hasAllRequiredFields){
        return {}
    }
    const address = {
        street1,
        street2,
        city,
        stateAcronym,
        stateName: mapStateToFullName(stateAcronym),
        zip,
    }
    log('getAddressObjectFromPlacesAPI', { address })
    return address
}


//  location_type stores additional data about the specified location.
//  https://developers.google.com/maps/documentation/javascript/reference/geocoder#GeocoderLocationType
//  types && location_type => https://developers.google.com/maps/documentation/geocoding/overview
const isDeliverableAddress = ({ types, geometry: { location_type } }) => (
    location_type === 'ROOFTOP' ||
    types.includes('street_address') ||
    types.includes('premise') ||
    types.includes('subpremise')
)

const getAddress = async (inputString) => {
    const { data: { results } } = await Axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${inputString}&key=${PLACES_KEY}`)
    return results
}

export const getAddressObjectFromDescription = async ({ description }) => {
    // Return places API results based on an input string
    // Geocoding API - https://developers.google.com/maps/documentation/geocoding/overview
    log('getAddressObjectFromDescription START', { description, })
    try {
        const results = await getAddress(description)
        const addresses = (
            results
                .filter(isDeliverableAddress)
                .map(getAddressObjectFromPlacesAPI)
                .filter(addressHasRequiredFields)
        )
        log('getAddressObjectFromDescription END', { description, addresses })
        return addresses
    } catch (err) {
        error('getAddressObjectFromDescription FAILED', err);
        return []
    }
}
